export const categories = [
  { slug: 'dianshiju', name: '电视剧', icon: 'ri-tv-line', description: '热门电视剧全集合集，极速高清不卡顿' },
  { slug: 'dianying', name: '电影', icon: 'ri-film-line', description: '最新电影大片，高清在线观看' },
  { slug: 'dongman', name: '动漫', icon: 'ri-emotion-line', description: '热血动漫番剧，秒开即播' },
  { slug: 'zongyi', name: '综艺', icon: 'ri-mic-line', description: '热门综艺节目，欢笑不断' },
  { slug: 'jilupian', name: '纪录片', icon: 'ri-earth-line', description: '精品纪录片，探索世界' },
];

export const getCategoryBySlug = (slug: string) => {
  return categories.find((c) => c.slug === slug);
};